import classnames from 'classnames/bind'
import Link from 'components/shared/Link'
import useArticleCardMouseAnimations from 'hooks/useArticleCardMouseAnimations'
import useSetStyle from 'hooks/useSetStyle'
import React, { forwardRef, useCallback, useRef } from 'react'
import ArticleCardHorizontalContent from './ArticleCardContentHorizontal'
import CardCover from '../ArticleCard/CardCover'
import { ReactComponent as FeaturedDecoration } from '../ArticleCard/featured-decoration.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ArticleCardHorizontal = ({
  children,
  className,
  forwardRef,
  image,
  link,
  ...rest
}) => {
  const componentRef = useRef()
  const cardRef = useRef()
  const linkRef = useRef()
  const coverRef = useRef()
  const coverImgRef = useRef()

  const setRef = useCallback((node) => {
    forwardRef && (forwardRef.current = node)
    componentRef.current = node
  }, [])

  const setLinkStyle = useSetStyle(linkRef)
  const setCoverStyle = useSetStyle(coverRef)
  const setCoverImgStyle = useSetStyle(coverImgRef)

  const span = 0.01
  const [_, mouseEvents] = useArticleCardMouseAnimations(
    {
      coverRef,
    },
    (progress) => {
      if (setLinkStyle) {
        setCoverStyle({
          scale: span * progress + 1,
        })
        setCoverImgStyle({
          scale: -span * progress + 1.04,
        })
      }
    }
  )

  return (
    <li ref={setRef} className={cx(className, css.ArticleCard)}>
      <div ref={cardRef} className={cx(css.cardContainerHorizon)}>
        <div className={css.cardContentHorizon}>
          <ArticleCardHorizontalContent
            href={link}
            {...rest}
          />
        </div>
        {image && (
          <Link href={link} {...mouseEvents} className={css.coverImageWrapperHorizon}>
            <div
              ref={coverRef}
              className={cx(css.coverImageContainer)}
            >
              <div ref={coverImgRef} className={css.coverImage}>
                <CardCover
                  image={image}
                  {...image}
                  {...rest}
                />
              </div>
            </div>
            <FeaturedDecoration className={css.decoration} />
          </Link>
        )}
      </div>
    </li>
  )
}

export const ArticleCardHorizontalProps = {
  theme: 'green',
  customCardProps: {
    featured: false,
  },
}

ArticleCardHorizontal.defaultProps = {
  ...ArticleCardHorizontalProps,
}

export default forwardRef((props, ref) => (
  <ArticleCardHorizontal {...props} forwardRef={ref} />
))
